// source: src/services/dscds/cc/cc.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.services.dscds.cc.AlertLevel', null, global);
goog.exportSymbol('proto.loupe.services.dscds.cc.CCInput', null, global);
goog.exportSymbol('proto.loupe.services.dscds.cc.CCOutput', null, global);
goog.exportSymbol('proto.loupe.services.dscds.cc.CCOutputContainer', null, global);
goog.exportSymbol('proto.loupe.services.dscds.cc.PredictionCategory', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.services.dscds.cc.CCInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.services.dscds.cc.CCInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.services.dscds.cc.CCInput.displayName = 'proto.loupe.services.dscds.cc.CCInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.services.dscds.cc.CCOutput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.services.dscds.cc.CCOutput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.services.dscds.cc.CCOutput.displayName = 'proto.loupe.services.dscds.cc.CCOutput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.services.dscds.cc.CCOutputContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.services.dscds.cc.CCOutputContainer.repeatedFields_, null);
};
goog.inherits(proto.loupe.services.dscds.cc.CCOutputContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.services.dscds.cc.CCOutputContainer.displayName = 'proto.loupe.services.dscds.cc.CCOutputContainer';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.services.dscds.cc.CCInput.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.services.dscds.cc.CCInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.services.dscds.cc.CCInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.services.dscds.cc.CCInput}
 */
proto.loupe.services.dscds.cc.CCInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.services.dscds.cc.CCInput;
  return proto.loupe.services.dscds.cc.CCInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.services.dscds.cc.CCInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.services.dscds.cc.CCInput}
 */
proto.loupe.services.dscds.cc.CCInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.services.dscds.cc.CCInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.services.dscds.cc.CCInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.services.dscds.cc.CCInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string org_id = 1;
 * @return {string}
 */
proto.loupe.services.dscds.cc.CCInput.prototype.getOrgId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.services.dscds.cc.CCInput} returns this
 */
proto.loupe.services.dscds.cc.CCInput.prototype.setOrgId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string team_id = 2;
 * @return {string}
 */
proto.loupe.services.dscds.cc.CCInput.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.services.dscds.cc.CCInput} returns this
 */
proto.loupe.services.dscds.cc.CCInput.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.services.dscds.cc.CCOutput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.services.dscds.cc.CCOutput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCOutput.toObject = function(includeInstance, msg) {
  var f, obj = {
    predictionCategory: jspb.Message.getFieldWithDefault(msg, 1, 0),
    mean: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    alertScore: jspb.Message.getFieldWithDefault(msg, 3, 0),
    alertLevel: jspb.Message.getFieldWithDefault(msg, 4, 0),
    suggestedActionsMap: (f = msg.getSuggestedActionsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.services.dscds.cc.CCOutput}
 */
proto.loupe.services.dscds.cc.CCOutput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.services.dscds.cc.CCOutput;
  return proto.loupe.services.dscds.cc.CCOutput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.services.dscds.cc.CCOutput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.services.dscds.cc.CCOutput}
 */
proto.loupe.services.dscds.cc.CCOutput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.loupe.services.dscds.cc.PredictionCategory} */ (reader.readEnum());
      msg.setPredictionCategory(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMean(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAlertScore(value);
      break;
    case 4:
      var value = /** @type {!proto.loupe.services.dscds.cc.AlertLevel} */ (reader.readEnum());
      msg.setAlertLevel(value);
      break;
    case 5:
      var value = msg.getSuggestedActionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.services.dscds.cc.CCOutput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.services.dscds.cc.CCOutput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCOutput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPredictionCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMean();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = /** @type {!proto.loupe.services.dscds.cc.AlertLevel} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSuggestedActionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional PredictionCategory prediction_category = 1;
 * @return {!proto.loupe.services.dscds.cc.PredictionCategory}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.getPredictionCategory = function() {
  return /** @type {!proto.loupe.services.dscds.cc.PredictionCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.loupe.services.dscds.cc.PredictionCategory} value
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.setPredictionCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double mean = 2;
 * @return {number}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.getMean = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.setMean = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint32 alert_score = 3;
 * @return {number}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.getAlertScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.setAlertScore = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.clearAlertScore = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.hasAlertScore = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AlertLevel alert_level = 4;
 * @return {!proto.loupe.services.dscds.cc.AlertLevel}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.getAlertLevel = function() {
  return /** @type {!proto.loupe.services.dscds.cc.AlertLevel} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loupe.services.dscds.cc.AlertLevel} value
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.setAlertLevel = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.clearAlertLevel = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.hasAlertLevel = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, string> suggested_actions = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.getSuggestedActionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.loupe.services.dscds.cc.CCOutput} returns this
 */
proto.loupe.services.dscds.cc.CCOutput.prototype.clearSuggestedActionsMap = function() {
  this.getSuggestedActionsMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.services.dscds.cc.CCOutputContainer.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.services.dscds.cc.CCOutputContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.services.dscds.cc.CCOutputContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCOutputContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
    ccOutputsList: jspb.Message.toObjectList(msg.getCcOutputsList(),
    proto.loupe.services.dscds.cc.CCOutput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.services.dscds.cc.CCOutputContainer}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.services.dscds.cc.CCOutputContainer;
  return proto.loupe.services.dscds.cc.CCOutputContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.services.dscds.cc.CCOutputContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.services.dscds.cc.CCOutputContainer}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.loupe.services.dscds.cc.CCOutput;
      reader.readMessage(value,proto.loupe.services.dscds.cc.CCOutput.deserializeBinaryFromReader);
      msg.addCcOutputs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.services.dscds.cc.CCOutputContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.services.dscds.cc.CCOutputContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.services.dscds.cc.CCOutputContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCcOutputsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.loupe.services.dscds.cc.CCOutput.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CCOutput cc_outputs = 1;
 * @return {!Array<!proto.loupe.services.dscds.cc.CCOutput>}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.getCcOutputsList = function() {
  return /** @type{!Array<!proto.loupe.services.dscds.cc.CCOutput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.services.dscds.cc.CCOutput, 1));
};


/**
 * @param {!Array<!proto.loupe.services.dscds.cc.CCOutput>} value
 * @return {!proto.loupe.services.dscds.cc.CCOutputContainer} returns this
*/
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.setCcOutputsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.loupe.services.dscds.cc.CCOutput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.services.dscds.cc.CCOutput}
 */
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.addCcOutputs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.loupe.services.dscds.cc.CCOutput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.services.dscds.cc.CCOutputContainer} returns this
 */
proto.loupe.services.dscds.cc.CCOutputContainer.prototype.clearCcOutputsList = function() {
  return this.setCcOutputsList([]);
};


/**
 * @enum {number}
 */
proto.loupe.services.dscds.cc.AlertLevel = {
  NORMAL: 0,
  WARNING: 1,
  CRITICAL: 2
};

/**
 * @enum {number}
 */
proto.loupe.services.dscds.cc.PredictionCategory = {
  CHURN: 0,
  CONTRACTION: 1,
  CURRENTLYWON: 2,
  REMAININGWEIGHTEDPIPELINE: 3,
  PROJREMAININQTR: 4,
  PROJREMAINPULLEDIN: 5,
  NETNEWARR: 6
};

goog.object.extend(exports, proto.loupe.services.dscds.cc);
